import { mutation, query } from "@core/helpers/graphql";
import { has_ssr } from "@core/helpers/render-type";
import { CHANGE_PASSWORD, HAS_USER, LOGIN, LOGIN_SEND_SMS, REGISTER, REGISTER_SEND_SMS, RESET_PASSWORD_SEND_EMAIL, RESET_PASSWORD_SEND_SMS, RESET_PASSWORD_VERIFY, SMS_LOGIN_VERIFY_TOKEN, UPDATE_COMPANY, UPDATE_USER, UPDATE_USER_IDENTITY, UPDATE_USER_IDENTITY_WITH_ADDRESS, UPDATE_USER_MOBILE_SEND_SMS, UPDATE_USER_MOBILE_SEND_SMS_V2, UPDATE_USER_MOBILE_VERIFY_CURRENT_SMS, UPDATE_USER_MOBILE_VERIFY_SMS } from "./_mutations";
import { GET_ACL_QUERY, GET_CART_QUERY, GET_CART_TOTAL_PRICES_QUERY, GET_CART_WITH_ACL_QUERY, GET_CURRENT_USER_QUERY, GET_CURRENT_USER_TUTORIALS, GET_CURRENT_USER_WITH_CART_QUERY } from "@core/services/auth/_query";

export const has_user_mutation = async (variables, options = {}) => {
  const { gql } = options
  const result = await mutation(gql || HAS_USER, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}


export const register_send_sms_mutation = async (variables, options = {}) => {
  const { gql } = options;
  const result = await mutation(gql || REGISTER_SEND_SMS, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const login_send_sms_mutation = async (variables, options = {}) => {
  const { gql } = options;
  const result = await mutation(gql || LOGIN_SEND_SMS, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const sms_login_verify_token_mutation = async (variables, options = {}) => {
  const { gql } = options;
  const result = await mutation(gql || SMS_LOGIN_VERIFY_TOKEN, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}


export const login_mutation = async (variables, options = {}) => {
  const { gql } = options;

  const result = await mutation(gql || LOGIN, variables, options);
  // console.log('login result',result)
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const register_mutation = async (variables, options = {}) => {
  const { gql } = options;

  const result = await mutation(gql || REGISTER, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const reset_password_send_email_mutation = async (variables, options = {}) => {
  const { gql } = options;

  const result = await mutation(gql || RESET_PASSWORD_SEND_EMAIL, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const reset_password_verify_mutation = async (variables, options = {}) => {
  const { gql } = options;

  const result = await mutation(gql || RESET_PASSWORD_VERIFY, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

// The options used to go to `query()` as GraphQL variables (`gql` and `custom_gql` were sent to the backend) and never reached
// Apollo, so `fetchPolicy` / `context` were ignored. They are Apollo options now. In the browser the user is read with
// `network-only`: the field is cached by AuthContext on load and nothing invalidates it (`addTypename: false`), so a later
// call returned the user as it was before an edit until a reload (jument, chawk-bazar, ciseco had a local "fresh" copy).
// On the server the client already runs with `no-cache`.
export const get_current_user_query = async (options = {}) => {
  const { gql, custom_gql, ...apollo_options } = options;
  const result = await query(gql || GET_CURRENT_USER_QUERY(custom_gql), undefined, {
    ...(has_ssr() ? {} : { fetchPolicy: "network-only" }),
    ...apollo_options,
  });
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const get_current_user_tutorials_query = async (variables, options = {}) => {
  const { gql } = options;
  const result = await query(gql || GET_CURRENT_USER_TUTORIALS, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const get_current_user_with_cart_query = async (variables, options = {}) => {
  const { gql, custom_cart_mockup } = options;
  const result = await query(gql || GET_CURRENT_USER_WITH_CART_QUERY(custom_cart_mockup), variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const get_cart_query = async (variables, options = {}) => {
  const { gql, custom_cart_mockup } = options;
  const result = await query(gql || GET_CART_QUERY(custom_cart_mockup), variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const get_cart_with_acl_query = async (variables, options = {}) => {
  const { gql, custom_cart_mockup } = options;
  const result = await query(gql || GET_CART_WITH_ACL_QUERY(custom_cart_mockup), variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const get_acl_query = async (variables, options = {}) => {
  const { gql } = options;
  const result = await query(gql || GET_ACL_QUERY, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const get_cart_total_prices_query = async (variables, options = {}) => {
  const { gql, custom_cart_mockup } = options;
  const result = await query(gql || GET_CART_TOTAL_PRICES_QUERY(custom_cart_mockup), variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const update_user_mutation = async (variables, options = {}) => {
  const { gql } = options;

  const result = await mutation(gql || UPDATE_USER, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const update_company_mutation = async (variables, options = {}) => {
  const { gql } = options;

  const result = await mutation(gql || UPDATE_COMPANY, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const change_password_mutation = async (variables, options = {}) => {
  const { gql } = options;
  const result = await mutation(gql || CHANGE_PASSWORD, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const reset_password_send_sms_mutation = async (variables, options = {}) => {
  const { gql } = options;
  const result = await mutation(gql || RESET_PASSWORD_SEND_SMS, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const update_user_identity_mutation = async (variables, options = {}) => {
  const { gql } = options;

  const result = await mutation(gql || UPDATE_USER_IDENTITY, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const update_user_identity_with_create_address_mutation = async (variables, options = {}) => {
  const { gql } = options;

  const result = await mutation(gql || UPDATE_USER_IDENTITY_WITH_ADDRESS, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const update_user_mobile_send_sms_mutation = async (variables, options = {}) => {
  const { gql } = options;

  const result = await mutation(gql || UPDATE_USER_MOBILE_SEND_SMS, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const update_user_mobile_verify_sms_mutation = async (variables, options = {}) => {
  const { gql } = options;

  const result = await mutation(gql || UPDATE_USER_MOBILE_VERIFY_SMS, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

// step 1 of the 3 step mobile change flow. Takes no variables: the api decides
// where the code goes (the user's current mobile) and reports back through
// extra_data whether a code was sent at all.
export const update_user_mobile_send_sms_v2_mutation = async (variables, options = {}) => {
  const { gql } = options;

  const result = await mutation(gql || UPDATE_USER_MOBILE_SEND_SMS_V2, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

// step 2 of the 3 step mobile change flow: verify the current mobile's code and
// submit the new number, which then receives its own code.
export const update_user_mobile_verify_current_sms_mutation = async (variables, options = {}) => {
  const { gql } = options;

  const result = await mutation(gql || UPDATE_USER_MOBILE_VERIFY_CURRENT_SMS, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}
